export class AddressModel {
  line: string
  country: string
  location: string
  link: string

  constructor(obj: any = null) {
    this.line = obj?.line
    this.country = obj?.country
    this.location = obj?.location
    this.link = obj?.link
  }
}
